import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalFooter, Button, Row, Col } from 'reactstrap';
import Nouislider from 'nouislider-react';
import 'nouislider/distribute/nouislider.css';
import { useDispatch } from 'react-redux';
import { lookalikeAudience } from '../../../slices/veloxity/audience/LookalikeAudienceReducer';
import { showErrorAlert, showSuccessAlert } from '../../custom/sweetalertHelper';
import { findAllVeloxityAudience } from '../../../slices/veloxity/audience/FindAllAudienceReducer';
import { getAllTargetAudience } from '../../../slices/veloxity/targetAudience/getAllTargetAudience';

const DnaLookalikeModal = ({ isOpen, toggle, audienceId , audience}) => {
    const dispatch = useDispatch();
    const [sliderValue, setSliderValue] = useState(80);

    const handleApply = () => {
    
        dispatch(lookalikeAudience({ 
            audienceId, 
            lookalikeData: { percent: sliderValue } 
        }))
        .then((action) => {
            if (action.type.endsWith('fulfilled')) {
              showSuccessAlert('Success!', 'Lookalike calculation successful.');
              if (audience == 'target'){
                dispatch(getAllTargetAudience());
              }else{
                dispatch(findAllVeloxityAudience(false));
              }
            }
          })
          .catch((error) => {
            console.error('An error occurred:', error);
            showErrorAlert('Error!', 'Unable to calculate lookalike.');
          })
          .finally(() => {
            setSliderValue(80);
          });
    
        toggle();
    };
    

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalBody>
                <h5 style={{ textAlign: 'center', marginBottom: '20px' }}>Select Lookalike Percentage</h5>
                <Row>
                    <Col md={12} style={{ textAlign: 'center' }}>
                        <div data-slider-color="primary" data-slider-size="lg">
                            <Nouislider
                                range={{ min: 80, max: 100 }} 
                                start={sliderValue} 
                                tooltips 
                                step={0.25} 
                                connect={[true, false]} 
                                onSlide={(value) => setSliderValue(Number(value[0]))} // Update slider value on change
                            />
                        </div>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter style={{ justifyContent: 'center' }}>
                <Button color="secondary" onClick={toggle} style={{ marginRight: '10px' }}>Cancel</Button>
                <Button color="primary" onClick={handleApply}>Generate Lookalike</Button>
            </ModalFooter>
        </Modal>
    );
};

export default DnaLookalikeModal;
